<template>
  <SpaceDetail v-if="showSpaceDetail" />
  <section
    v-else
    class="is-small"
  >
    <layout-page-menu>
      <template #pageContent>
        <SpacesList v-if="pageView === 'spaces'" />
        <CheckLocationSpaces v-if="pageView === 'check'" />
      </template>
    </layout-page-menu>
  </section>
</template>

<script>
import SpacesList from '../../Spaces/SpacesList.vue'
import CheckLocationSpaces from '../../Spaces/CheckLocationSpaces.vue'
import SpaceDetail from './Spaces/SpaceDetail.vue'
import { mapMutations, mapState } from 'vuex/dist/vuex.common'
export default {
  name: 'LocationSpaces',

  components: {
    SpacesList,
    CheckLocationSpaces,
    SpaceDetail
  },

  data(vm) {
    return {
      activeMenu: vm.$store.state.spaceStore.pageView,
      wSpaceId: null,
      showSpaceDetail: false,
      spaceId: vm.$route.params.spaceId || 0
    }
  },

  computed: {
    ...mapState('spaceStore', ['pageView']),

    submenuItems() {
      return [
        {
          label: 'Spaces',
          view: 'spaces',
        },
        {
          label: 'Check spaces',
          view: 'check',
        },
      ]
    }
  },

  created() {
    this.wSpaceId = this.$watch(() => this.$route.params.spaceId, (val) => {
      this.showSpaceDetail = (isNaN(val) ? false : true)
    }, { immediate: true })
  },

  beforeDestroy() {
    !this.$route.name.includes('locations-location-spaces') && this.setPageView('spaces')
  },

  provide() {
    // use function syntax so that we can access `this`
    let submenu = []
    Object.defineProperty(submenu, 'menuItems', {
      enumerable: true,
      get: () => this.submenuItems
    })

    return {
      submenu,
      selectedView: this.activeMenu,
      callbackSelectSubmenu: this.setActiveMenu
    }
  },

  methods: {
    ...mapMutations('spaceStore', ['setPageView']),

    setActiveMenu(submenuItem) {
      this.setPageView(submenuItem.view)
    },
  }
}
</script>